import { apiGet, apiPost, planningPath } from './PlanningApiClient';

export type InsightSeverity = 'critical' | 'warning' | 'info';

export interface Insight {
  key: string;
  rule: string;
  severity: InsightSeverity;
  title: string;
  detail: string;
  action?: string;
  href?: string;
  amountNaira?: number;
  dismissed?: boolean;
}

export interface InsightSummary {
  insights: Insight[];
  counts: Record<InsightSeverity, number>;
  atStakeNaira: number;
}

const EMPTY: InsightSummary = {
  insights: [],
  counts: { critical: 0, warning: 0, info: 0 },
  atStakeNaira: 0,
};

/**
 * Insights are recomputed server-side on every call, so there is nothing to
 * cache or invalidate here — a stale insight is worse than a slow one.
 */
export async function loadInsights(includeDismissed = false): Promise<InsightSummary> {
  try {
    const res = await apiGet<InsightSummary>(
      planningPath(`/insights${includeDismissed ? '?includeDismissed=true' : ''}`)
    );
    return res ?? EMPTY;
  } catch (error) {
    console.error('Failed to load insights:', error);
    return EMPTY;
  }
}

export async function dismissInsight(key: string, reason?: string): Promise<boolean> {
  try {
    await apiPost(planningPath('/insights/dismiss'), { key, reason });
    return true;
  } catch (error) {
    console.error('Failed to dismiss insight:', error);
    return false;
  }
}

export async function restoreInsight(key: string): Promise<boolean> {
  try {
    await apiPost(planningPath('/insights/restore'), { key });
    return true;
  } catch (error) {
    console.error('Failed to restore insight:', error);
    return false;
  }
}
